"use strict";
/**
 * The owner's "view as" picker: filter users by name, draw the tappable list.
 * Pure; the handler owns loading, selection and the banner
 * (ai/PNL_TOTALS_PLAN.md §20).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterUsers = filterUsers;
exports.renderUserResults = renderUserResults;
const pnl_display_1 = require("./pnl-display");
/** Users whose name contains `query`, ignoring case; everyone when it's blank. */
function filterUsers(users, query) {
    const needle = query.trim().toLowerCase();
    return needle
        ? users.filter((u) => u.name.toLowerCase().includes(needle))
        : [...users];
}
/** One button per user — a real tap target, no hover affordance. */
function renderUserResults(users, el) {
    el.innerHTML =
        users.length === 0
            ? `<div class="pnl-view-as-empty">No matching users</div>`
            : users
                .map((u) => `<button type="button" class="pnl-view-as-option" role="option" data-user-id="${(0, pnl_display_1.esc)(u.id)}">
							<span>${(0, pnl_display_1.esc)(u.name)}</span>${u.traded ? "" : `<span class="pnl-view-as-note">no trades</span>`}
						</button>`)
                .join("");
}
